(function () {
  'use strict';
  const weekdays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  const own = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
  const minutes = value => Number(value.slice(0, 2)) * 60 + Number(value.slice(3));
  const clock = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  function validateSlot(slot) {
    if (slot === null) return;
    if (!Array.isArray(slot) || slot.length !== 2 ||
        !slot.every(t => typeof t === 'string' && clock.test(t)) ||
        minutes(slot[0]) >= minutes(slot[1])) throw new Error('Ungültige Öffnungszeit');
  }
  function validate(schedule) {
    if (!schedule || !schedule.weekly || !Array.isArray(schedule.months) ||
        !schedule.months.length || !schedule.months.every(m => Number.isInteger(m) && m >= 1 && m <= 12) ||
        !schedule.exceptions || Array.isArray(schedule.exceptions) ||
        typeof schedule.exceptions !== 'object') throw new Error('Ungültige Tabelle');
    for (let day = 0; day < 7; day++) {
      if (!own(schedule.weekly, day)) throw new Error('Wochentag fehlt');
      validateSlot(schedule.weekly[day]);
    }
    for (const [date, slot] of Object.entries(schedule.exceptions)) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new Error('Ungültiges Datum');
      const parsed = new Date(date + 'T12:00:00Z');
      if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) {
        throw new Error('Ungültiges Datum');
      }
      validateSlot(slot);
    }
    return schedule;
  }
  function localParts(now) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).map(p => [p.type, p.value]));
    return {
      // UTC noon represents a calendar day, not an opening-time instant.
      day: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12)),
      minute: +parts.hour * 60 + +parts.minute
    };
  }
  function slotFor(schedule, day) {
    const key = day.toISOString().slice(0, 10);
    if (own(schedule.exceptions, key)) return schedule.exceptions[key];
    if (!schedule.months.includes(day.getUTCMonth() + 1)) return null;
    return schedule.weekly[day.getUTCDay()];
  }
  // kind: open (jetzt offen), today (heute später), tomorrow, next (anderer Tag), unknown
  function status(schedule, now) {
    const local = localParts(now);
    const slot = slotFor(schedule, local.day);
    if (slot && local.minute < minutes(slot[1])) {
      const isOpen = local.minute >= minutes(slot[0]);
      return {state: isOpen ? 'open' : 'scheduled', kind: isOpen ? 'open' : 'today',
        day: weekdays[local.day.getUTCDay()], from: slot[0], to: slot[1]};
    }
    // Do not imply an unconfirmed date months into the next season.
    for (let offset = 1; offset <= 7; offset++) {
      const next = new Date(local.day);
      next.setUTCDate(next.getUTCDate() + offset);
      const hours = slotFor(schedule, next);
      if (hours) return {state: 'closed', kind: offset === 1 ? 'tomorrow' : 'next',
        day: weekdays[next.getUTCDay()], from: hours[0], to: hours[1]};
    }
    return {state: 'closed', kind: 'unknown', day: '', from: '', to: ''};
  }
  function format(template, result) {
    return String(template)
      .replace(/\{tag\}/g, result.day)
      .replace(/\{von\}/g, result.from)
      .replace(/\{bis\}/g, result.to)
      .replace(/\s+/g, ' ').trim();
  }
  // Split "Morgen geöffnet von 16:00 bis 19:00 Uhr" into lead + time part for mobile line break.
  function split(text) {
    const m = text.match(/^(.*?)\s((?:von|ab|bis)\s.*)$/);
    return m ? [m[1], m[2]] : [text, ''];
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {validate, status, format, split};
  if (typeof window === 'undefined' || !window.customElements ||
      window.customElements.get('stepan-hours')) return;
  class StepanHours extends HTMLElement {
    connectedCallback() {
      this.label = this.querySelector('[data-stepan-hours-text]');
      if (!this.label) return;
      this.fallback = this.label.textContent;
      try { this.schedule = validate(JSON.parse(this.dataset.schedule)); }
      catch (_) { return; }
      this.refresh = () => {
        try {
          const result = status(this.schedule, new Date());
          const template = this.dataset[result.kind];
          if (!template) throw new Error('Status-Text fehlt');
          const text = format(template, result);
          if (this.label.getAttribute('aria-label') !== text) {
            const [lead, rest] = split(text);
            this.label.setAttribute('aria-label', text);
            this.label.textContent = '';
            const a = document.createElement('span');
            a.className = 'stepan-hours__lead';
            a.setAttribute('aria-hidden', 'true');
            a.textContent = lead;
            this.label.appendChild(a);
            if (rest) {
              const b = document.createElement('span');
              b.className = 'stepan-hours__time';
              b.setAttribute('aria-hidden', 'true');
              b.textContent = rest;
              this.label.appendChild(document.createTextNode(' '));
              this.label.appendChild(b);
            }
          }
          this.dataset.state = result.state;
        } catch (_) {
          this.label.removeAttribute('aria-label');
          this.label.textContent = this.fallback;
          delete this.dataset.state;
        }
      };
      this.refresh();
      this.timer = window.setInterval(this.refresh, 30000);
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  }
  window.customElements.define('stepan-hours', StepanHours);
})();
